"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/prefer-default-export, camelcase */
var combineLearningPanelFreeUrl_1 = __importDefault(require("./combineLearningPanelFreeUrl"));
var rest_1 = __importDefault(require("../../../rest"));
var challengesApi_1 = __importDefault(require("../../mock/challengesApi"));
var ChallengesAPIs = {
    getChallenges: function () {
        return rest_1.default.get({
            mockFunc: function () { return challengesApi_1.default; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/games/free'),
        });
    },
};
exports.default = ChallengesAPIs;
